import { observer } from 'mobx-react-lite';
import { useResolve } from '@/tsyringe-hooks/useResolve';
import { ShareLinksDialogStore, TOKEN_ShareLinksDialogStore } from './ShareLinksDialogStore';
import { Button } from '@/components/ui/button';
import { CircleOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ExistingShareLinkStore from '../transient/ExistingShareLinkStore';

const ShareLinksDialogView = observer(() => {
    const store = useResolve<ShareLinksDialogStore>(TOKEN_ShareLinksDialogStore);
    const { t } = useTranslation();

    const myShareLinks = store.shareLinkStores.filter(linkStore => linkStore.isCreatedByMe);
    const otherShareLinks = store.shareLinkStores.filter(linkStore => !linkStore.isCreatedByMe);

    const renderLinkList = (linkStores: ExistingShareLinkStore[]
    ) => (
        linkStores.length > 0 ? linkStores.map((linkStore) => (
            <div key={linkStore.id} className="flex items-center mb-2 mt-2">
                <div className="flex-grow overflow-hidden">
                    <h4 className={`truncate ${!linkStore.isActive ? 'line-through' : ''}`}>
                        {linkStore.id}
                    </h4>
                    {linkStore.isActive && <p>
                        {linkStore.accessLevelDisplay} ({linkStore.usageDisplay})
                    </p>}
                </div>
                {linkStore.isActive && (
                    <Button
                        title={t('disable_share_link')}
                        size="iconsm"
                        variant="destructive"
                        onClick={linkStore.disable}
                        className="ml-auto mr-1"
                    >
                        <CircleOff />
                    </Button>
                )}
            </div>
        )) : <p>{t('no_share_links')}</p>
    );

    return (
        <div>
            <h3>{t('my_share_links')}</h3>
            {renderLinkList(myShareLinks)}

            <h3 className='mt-4'>{t('other_share_links')}</h3>
            {renderLinkList(otherShareLinks)}
        </div>
    );
});

export default ShareLinksDialogView;